/**
 * GLSL shared by the kit's materials: a cheap 3D value noise and hash for the body patterns (kit/bodyMaterial.ts).
 * Kept small: these run on every pixel of a skinned tower.
 */
export const KIT_NOISE_GLSL = /* glsl */ `
float tdHash3(vec3 p) { p = fract(p * 0.3183099 + 0.1); p *= 17.0; return fract(p.x * p.y * p.z * (p.x + p.y + p.z)); }
float tdNoise3(vec3 x) {
  vec3 i = floor(x), f = fract(x);
  f = f * f * (3.0 - 2.0 * f);
  return mix(mix(mix(tdHash3(i), tdHash3(i + vec3(1, 0, 0)), f.x), mix(tdHash3(i + vec3(0, 1, 0)), tdHash3(i + vec3(1, 1, 0)), f.x), f.y),
             mix(mix(tdHash3(i + vec3(0, 0, 1)), tdHash3(i + vec3(1, 0, 1)), f.x), mix(tdHash3(i + vec3(0, 1, 1)), tdHash3(i + vec3(1, 1, 1)), f.x), f.y), f.z);
}`;
